// Item.tsx
import { useSelector } from 'react-redux'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { ClusterInterface, MetricsSummary } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import payment from '../../../../../assets/images/icons/payment.svg'
import extend from '../../../../../assets/images/icons/proceed.svg'
import chart from '../../../../../assets/images/icons/chart.svg'
import { selectCurrentCluster } from '../../../../../store/slices/currentClusterSlice'
import { format, differenceInDays } from 'date-fns'
import { selectCurrentUser } from '../../../../../store/slices/currentUserSlice'
import { chatAdminId } from '../../../../../common/utils/constants'

const getStatus = (el: ClusterInterface) => {
  if (!el.billing?.paidUntil) return { color: '#999999', text: '—', bg: 'transparent' }

  const now = new Date()
  const paidUntil = new Date(el.billing.paidUntil)
  const daysLeft = differenceInDays(paidUntil, now)

  if (!el.isActive) return { color: '#e74c3c', text: 'Заблокирован', bg: '#fde8e8' }
  if (daysLeft < 0) return { color: '#e74c3c', text: 'Просрочен', bg: '#fde8e8' }
  if (daysLeft <= 7) return { color: '#f39c12', text: `${daysLeft} дн.`, bg: '#fef5e7' }
  return { color: '#27ae60', text: `до ${format(paidUntil, 'dd.MM.yy')}`, bg: '#e8f8f0' }
}

type Props = {
  startEdit: (el: ClusterInterface) => void
  el: ClusterInterface
  showDetails: (el: ClusterInterface) => void
  showStats: (el: ClusterInterface) => void
  switchCluster: (el: ClusterInterface) => void
  openPayment: (el: ClusterInterface) => void
  openExtend: (el: ClusterInterface) => void
  metrics?: MetricsSummary | null
}

export const Item = ({
  startEdit,
  el,
  showDetails,
  switchCluster,
  openPayment,
  openExtend,
  metrics,
  showStats,
}: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  const currentCluster = useSelector(selectCurrentCluster)
  const currentUser = useSelector(selectCurrentUser)

  const isAdmin = currentUser?.id === chatAdminId
  const hasBilling = el.billing?.monthlyPrice && el.billing.monthlyPrice > 0
  const status = getStatus(el)

  return (
    <div className={currentCluster?.id === el.id ? classes.current : ''}>
      <div
        className={darkTheme ? classes.containerDark : classes.container}
        onClick={() => switchCluster(el)}
      >
        <div className={classes.contentContainer}>
          <div className={classes.nameAndDescription}>
            <div className={classes.name}>
              <span className={classes.statusDot} style={{ backgroundColor: status.color }} />
              {shortenText(el.name, 50)}
            </div>
            <div className={classes.row}>
              <div className={classes.item}>
                <span className={classes.label}>Статус</span>
                <span
                  className={classes.statusBadge}
                >
                  {status.text}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>Польз.</span>
                <span className={classes.value}>{el.registeredUsersCount ?? '—'}</span>
              </div>
              {/* {hasBilling && isAdmin && (
                <div className={classes.item}>
                  <span className={classes.label}>Тариф</span>
                  <span className={classes.value}>{el.billing?.monthlyPrice ?? '—'} ₽/мес</span>
                </div>
              )} */}
              {metrics && (
                <>
                  <div className={classes.item}>
                    <span className={classes.label}>Визиты</span>
                    <span className={classes.value}>{metrics.today.visits}</span>
                  </div>
                  <div className={classes.item}>
                    <span className={classes.label}>Лиды</span>
                    <span className={classes.value}>{metrics.today.goals.call_request || 0}</span>
                  </div>
                  <div className={classes.item}>
                    <span className={classes.label}>Звонки</span>
                    <span className={classes.value}>{metrics.today.goals.call_click || 0}</span>
                  </div>
                  <div className={classes.item}>
                    <span className={classes.label}>Заказы</span>
                    <span className={classes.value}>
                      {(metrics.today.goals.order_complete || 0) +
                        (metrics.today.goals.project_order || 0)}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className={classes.buttons}>
          {hasBilling && currentUser?.id === chatAdminId && (
            <IconButton
              display
              onClick={() => {
                if (openExtend) openExtend(el)
              }}
              icon={extend}
              alt="Продлить"
              small
            />
          )}
          {hasBilling && (
            <IconButton
              display
              onClick={() => openPayment(el)}
              icon={payment}
              alt="Оплатить"
              small
            />
          )}
          {metrics && (
            <IconButton display onClick={() => showStats(el)} icon={chart} alt="Статистика" small />
          )}
          <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
          <IconButton display onClick={() => startEdit(el)} icon={edit} alt="Изменить" small />
        </div>
      </div>
    </div>
  )
}
